export const MENUETT = 6;
export const LIBRETTOVÅRDGIVARE = 2;
export const SYMFONIVÅRDGIVARE = 4;
export const SYMFONIKOMMUN = 5;
export const MENUETTPORTAL = 8;
export const MENUETTPORTALKOMMUN = 9;